// ----------- AUTH
export const UPDATE_CHANNEL_KEY = 'UPDATE_CHANNEL_KEY';
export const UPDATE_API_KEY = 'UPDATE_API_KEY';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const CLEAR_USER_INFO = 'CLEAR_USER_INFO';
export const SET_IS_GEO_BLOCKED = 'SET_IS_GEO_BLOCKED';
export const UPDATE_USER_FEATURES = 'UPDATE_USER_FEATURES';

// ----------- CALENDAR
export const UPDATE_LIST_PARAMS = 'UPDATE_LIST_PARAMS';
export const UPDATE_CALENDAR_PARAMS = 'UPDATE_CALENDAR_PARAMS';
export const RESET_EVENT_PARAMS = 'RESET_EVENT_PARAMS';

// ----------- CHANNEL
export const UPDATE_CHANNEL_SETTINGS = 'UPDATE_CHANNEL_SETTINGS';
export const UPDATE_CHANNEL_MENU = 'UPDATE_CHANNEL_MENU';
export const UPDATE_GROUP_MENU = 'UPDATE_GROUP_MENU';
export const UPDATE_PARTICIPANT_MENU = 'UPDATE_PARTICIPANT_MENU';
export const UPDATE_MAIN_CHANNEL_SLIDES = 'UPDATE_MAIN_CHANNEL_SLIDES';
export const UPDATE_CHANNEL_PAGES = 'UPDATE_CHANNEL_PAGES';
export const UPDATE_CHANNEL_COLORS = 'UPDATE_CHANNEL_COLORS';
export const UPDATE_INTERFACE_LANGUAGE = 'UPDATE_INTERFACE_LANGUAGE';
export const UPDATE_STATIC_BLOCKS = 'UPDATE_STATIC_BLOCKS';
export const UPDATE_ATTRIBUTES = 'UPDATE_ATTRIBUTES';
export const UPDATE_UI_BLOCKS = 'UPDATE_UI_BLOCKS';

// ----------- CUSTOM FORM
export const UPDATE_CUSTOM_FORM_DATA = 'UPDATE_CUSTOM_FORM_DATA';

// ----------- EVENT
export const UPDATE_EVENTS_CATEGORIES = 'UPDATE_EVENTS_CATEGORIES';
export const UPDATE_EVENTS_LOCATIONS = 'UPDATE_EVENTS_LOCATIONS';

// ----------- FAQ
export const UPDATE_FAQ = 'UPDATE_FAQ';

// ----------- GEO
export const UPDATE_GEO_DATA = 'UPDATE_GEO_DATA';

// ----------- PARTICIPANTS
export const UPDATE_PARTICIPANTS_LIST = 'UPDATE_PARTICIPANTS_LIST';
export const UPDATE_PARTICIPANT_GROUP_LIST = 'UPDATE_PARTICIPANT_GROUP_LIST';
export const UPDATE_PARTICIPANTS_PROPS = 'UPDATE_PARTICIPANTS_PROPS';

// ----------- PAYMENT
export const UPDATE_PACKAGES_LIST = 'UPDATE_PACKAGES_LIST';
export const UPDATE_SUBSCRIPTIONS_LIST = 'UPDATE_SUBSCRIPTIONS_LIST';
export const UPDATE_ORDERS_LIST = 'UPDATE_ORDERS_LIST';
export const UPDATE_PURCHASED_PASSES = 'UPDATE_PURCHASED_PASSES';

// ----------- SETTINGS
export const ADD_TOAST = 'ADD_TOAST';
export const REMOVE_TOAST = 'REMOVE_TOAST';
export const SET_POPUP_DATA = 'SET_POPUP_DATA';
export const DELETE_POPUP = 'DELETE_POPUP';
export const UPDATE_CROSS_FILTER_DATA = 'UPDATE_CROSS_FILTER_DATA';
export const ADD_EVENT_TO_MULTI_VIEW = 'ADD_EVENT_TO_MULTI_VIEW';
export const REMOVE_EVENT_FROM_MULTI_VIEW = 'REMOVE_EVENT_FROM_MULTI_VIEW';
export const CLEAR_MULTI_VIEW = 'CLEAR_MULTI_VIEW';
export const SET_SUCCESS_BUY_CALLBACK = 'SET_SUCCESS_BUY_CALLBACK';
export const CLEAR_SUCCESS_BUY_CALLBACK = 'CLEAR_SUCCESS_BUY_CALLBACK';

// ----------- CLIPS
export const UPDATE_CLIPS = 'UPDATE_CLIPS';
export const UPDATE_ALL_CLIPS = 'UPDATE_ALL_CLIPS';
export const UPDATE_AUTO_CLIPS = 'UPDATE_AUTO_CLIPS';
export const CLEAR_AUTO_CLIPS = 'CLEAR_AUTO_CLIPS';

// ----------- FAVORITES
export const UPDATE_FAVORITES = 'UPDATE_FAVORITES';

// ----------- VOD
export const UPDATE_VOD_RAILS = 'UPDATE_VOD_RAILS';

// ------------ GLOBAL
export const CLEAR_CACHE = 'CLEAR_CACHE';
export const RESET_STATE = 'RESET_STATE';
